module.exports = __webpack_public_path__ + "media/images/childcare/cover-desktop-81e891c9b7a47cf5e6b903865e69687c.jpg";